import { ConfigurationsModel } from "../models/interfaces/config";

export const ConfigInitialState: ConfigurationsModel = {
    configurations: {}
};